import route from '@common/router'
import Breadcrumb from '@common/layout/components/Breadcrumb'

export default {
    components: {
        Breadcrumb,
    },
    data() {
        return {
            route,
        }
    },
    computed: {
        routeInfo() {
            return this.route.find(item => item.name === this.routeName)
        },
        tabs() {
            return (this.routeInfo.children || []).filter(i => {
                if (i.meta && i.meta.hideNav) {
                    const { hideNav } = i.meta
                    if (typeof hideNav === 'function') {
                        return !hideNav(this.$store)
                    }
                    return !hideNav
                }
                return true
            })
        },
        baseRoute() {
            const { appId, workspaceId } = this.$route.params
            return `/app/${appId}/workspace/${workspaceId}/${this.routeName}`
        },

    },
    methods: {
        isRouteActive(tab) {
            return this.$route.fullPath.includes(`${this.baseRoute}/${tab.path}`)
        },
    },
    
}
